import { render, staticRenderFns } from "./image-video.vue?vue&type=template&id=6c31a0ee&"
import script from "./image-video.vue?vue&type=script&lang=js&"
export * from "./image-video.vue?vue&type=script&lang=js&"
import style0 from "./image-video.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports